import React from 'react';

interface SuspenseLoadingProps {
  message?: string;
}

export function SuspenseLoading({ message = 'Loading...' }: SuspenseLoadingProps) {
  return (
    <div className="flex flex-col items-center justify-center min-h-[200px] space-y-4">

    </div>
  );
}